import GroupIndexingRule from './GroupIndexingRule.vue';

export const groupIndexingRuleRoutes = [
  { path: 'demand-indexing-rule', component: GroupIndexingRule, name: 'demand-indexing-rule' }
];
